import drawer from "./aiDrawer";
import warning from "../default-icons/warning";
export default {...drawer, warning};
